import { DatePicker } from 'components/DatePicker';
import { DaysInMonth } from 'utils';

interface OwnProps {
  rangeStartDate: Date;
  rangeEndDate: Date;
  selectDate: (date: Date) => void;
  currentMonth: Date;
  selectedDate?: Date | undefined;
  browseCalendar?: boolean;
  className?: string;
}

export const OrderHistoryDatePicker = ({
  rangeStartDate,
  rangeEndDate,
  selectDate,
  selectedDate,
  browseCalendar,
  currentMonth,
  className
}: OwnProps): JSX.Element => {
  const daysToDisplay = DaysInMonth(currentMonth);

  return (
    <DatePicker
      rangeStartDate={rangeStartDate}
      rangeEndDate={rangeEndDate}
      selectDate={selectDate}
      selectedDate={selectedDate}
      browseCalendar={browseCalendar}
      currentMonth={currentMonth}
      daysToDisplay={daysToDisplay}
      todaysDate={currentMonth}
      className={className}
    />
  );
};
